module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAONJREFUGBldjzFuwkAQRefvIggFlK65gS2nSJOCMxBFoono6OEOiI4DRD4CoqXKASLZ7LqMUucCaQgCZpi1sAVZaaXdv///nUeucAvn3JD+LdWSXb5bigighy8hebCws+Qx2QRvWZZPfOS1QPYEekUQTsdTBkLPwMzRws/tPQRxk8w02SehP013DJl53VyZgtF7/yxn2TJxF8A4TdN10MNqmqovgL5qB92hqZnR3M2kD7Zl35Tol4VXvvCjqknpcqUbKN20nuFKlzG4q6aRUaL3tm1PakNIxnH8qZQvhs1HFEXfF/TOcpRIKI1CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = 349
// module chunks = 0 2 5 6 8